import { ThemeEvents } from '@theme/events';

/**
 * Garde l'indicateur de stock synchronisé avec la variante choisie.
 *
 * Le thème réémet la section entière à chaque changement de variante : on y
 * pioche le seul noeud qui dépend du stock et on remplace le nôtre. Libellé,
 * couleurs et remplissage suivent, sans recalcul côté client.
 */
class HeritageStockBar extends HTMLElement {
  connectedCallback() {
    document.addEventListener(ThemeEvents.variantUpdated, this.updateStock);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.variantUpdated, this.updateStock);
  }

  updateStock = (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    const nouveau = html.querySelector('heritage-stock-bar [data-ref="heritage-stock-bar"]');
    const actuel = this.querySelector('[data-ref="heritage-stock-bar"]');

    if (!nouveau || !actuel) return;
    if (actuel.innerHTML === nouveau.innerHTML && actuel.getAttribute('style') === nouveau.getAttribute('style')) return;

    actuel.replaceWith(nouveau);
  };
}

if (!customElements.get('heritage-stock-bar')) {
  customElements.define('heritage-stock-bar', HeritageStockBar);
}
